import siteConfig from "site-config";
import { Observable } from "rxjs";
import { ajax } from "lib/observable";
import { COLLECTION_TIMELINE } from "constants/action-types";
import { add as snackbarAdd } from "actions/snackbars";
import { formatMessage } from "lib/globalize-util";
import { INotificationFilters } from "reducers/notifications";
import { stringify } from "query-string";
import { IStore } from "reducers";
export const PAGE_SIZE = 20;

export const fetchCollectionTimelineEpic = (action$, store: { getState: () => IStore }) => {
    return action$
        .ofType(COLLECTION_TIMELINE.FETCH.START)
        .map(({ payload }) => payload)
        .flatMap(({ collectionId, filters, next, brandId }) => {
            const { timeline, collection } = store.getState();
            const params: INotificationFilters = { limit: PAGE_SIZE, ...filters, merchant_id: collection.merchantId };

            if (next) {
                params.start_id_open = timeline.collectionTimeline[timeline.collectionTimeline.length - 1].id;
            }
            const feedUrl =
                brandId && brandId !== ""
                    ? `${siteConfig.goAPI}/v1/collections/${collectionId}/feed_items/brands/${brandId}?${stringify(
                          params
                      )}`
                    : `${siteConfig.goAPI}/v1/collections/${collectionId}/feed_items?${stringify(params)}`;
            return ajax({
                url: feedUrl,
                method: "GET",
            })
                .map(({ response }) => response)
                .flatMap(({ activities }) => {
                    return [
                        {
                            payload: {
                                results: next ? [...timeline.collectionTimeline, ...activities] : activities,
                                hasNextPage: activities.length === PAGE_SIZE,
                            },
                            type: COLLECTION_TIMELINE.FETCH.SUCCESS,
                        },
                    ];
                })
                .catch((error) =>
                    Observable.merge(
                        Observable.of({
                            payload: {
                                error: new Error(error),
                            },
                            type: COLLECTION_TIMELINE.FETCH.ERROR,
                        }),
                        Observable.of(
                            snackbarAdd({
                                message: error.message || formatMessage("Error fetching collection timeline"),
                            })
                        )
                    )
                );
        });
};
